import Immutable from 'seamless-immutable'
import _ from 'lodash'

import * as actions from './actions'

const initialState = Immutable.from({
  isFetching: false,
  error: false,
  payload: null,
  // When we get status OK from API this is set to true for a short moment
  // so that we can show a success message.
  isSuccessful: false,
  isSent: false, // Defines if AdReply should go back to the ad page after the message has been sent
  adReplyForm: {
    data: {
      name: {
        value: '',
        error: null,
      },
      email: {
        value: '',
        error: null,
      },
      body: {
        value: '',
        error: null,
      },
    },
  },
})

const sendmail = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.REQUEST_SENDMAIL:
      return state.merge({ isFetching: true, error: false })
    case actions.RECEIVE_SENDMAIL:
      if (error) {
        return state.merge({ isFetching: false, error: true })
      }
      return state.merge({ isFetching: false, error: false, payload })
    case actions.UPDATE_FORM_DATA: {
      const newData = {}
      _.forEach(payload, (value, key) => {
        newData[key] = {
          value,
        }
      })
      return state.merge({ adReplyForm: { data: newData } }, { deep: true }).set('isSent', false)
    }
    case actions.UPDATE_FORM_ERRORS: {
      const errors = {}
      let newValue
      _.forEach(Object.keys(state.adReplyForm.data), (key) => {
        // Reset errors that do not appear in the response to null
        // Because the user has corrected that particular error
        newValue = null
        if (key in payload.json) {
          newValue = payload.json[key]
        }
        errors[key] = {
          error: newValue,
        }
      })
      return state.merge({ adReplyForm: { data: errors } }, { deep: true })
    }
    case actions.UPDATE_FORM_SUCCESS: {
      const adReplyFormData = {}
      // Reset errors on success
      _.forEach(Object.keys(state.adReplyForm.data), (key) => {
        adReplyFormData[key] = {
          error: null,
        }
      })
      // Leave name and email but reset body when the user is done
      adReplyFormData.body.value = ''
      return state.merge(
        {
          isSuccessful: payload,
          adReplyForm: { data: adReplyFormData },
        },
        { deep: true },
      )
    }
    case actions.REMOVE_FORM_ERROR_MESSAGES: {
      const formData = _.mapValues(state.adReplyForm.data, (value) => ({ ...value, error: null }))
      return state.setIn(['adReplyForm', 'data'], formData)
    }
    case actions.HAS_MESSAGE_BEEN_SENT: {
      return state.set('isSent', payload)
    }
    default:
      return state
  }
}

export default sendmail
